"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderEditorView = void 0;
var _react = require("react");
var _useTeacherApi2 = require("../hooks/useTeacherApi");
var _studyYear = require("../../../utilities/studyYear");
var _EnvironmentManager = require("../EnvironmentManager.provider");
var _main = require("../../../main");
var _AudiencePickerView = require("./AudiencePickerView");
var _TeacherSelection = require("./components/TeacherSelection");
var _EnvironmentSelection = require("./components/EnvironmentSelection");
var _RangeDateSelection = require("./components/RangeDateSelection");
var _EnvironmentManager2 = _interopRequireDefault(require("../EnvironmentManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SliderEditorView = function SliderEditorView(props) {
  var _environmentData$Teac;
  var styles = (0, _EnvironmentManager2.default)();
  var mode = props.mode,
    productInfo = props.productInfo,
    environmentTitleMaxLength = props.environmentTitleMaxLength,
    enableRangeDateSelection = props.enableRangeDateSelection,
    isLearingSite = props.isLearingSite,
    onClose = props.onClose;
  var _ref = mode !== 'create' ? props : {},
    sourceEnvironmentId = _ref.sourceEnvironmentId;
  var isInCreationMode = ['create', 'duplicate'].includes(mode);
  var _useContext = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext),
    userSessionData = _useContext.userSessionData,
    schoolYear = _useContext.schoolYear,
    defaultEnvironmentTeachers = _useContext.defaultEnvironmentTeachers,
    srcEnvironmentId = _useContext.srcEnvironmentId,
    userEnvironments = _useContext.userEnvironments,
    environmentData = _useContext.environmentData,
    getLabel = _useContext.getLabel,
    setPreloaderMode = _useContext.setPreloaderMode,
    setSliderView = _useContext.setSliderView,
    setSchoolYear = _useContext.setSchoolYear,
    setUserEnvironments = _useContext.setUserEnvironments,
    setEnvironmentIds = _useContext.setEnvironmentIds,
    setEnvironmentSchoolId = _useContext.setEnvironmentSchoolId,
    setEnvironmentTitle = _useContext.setEnvironmentTitle,
    setEnvironmentProductInfo = _useContext.setEnvironmentProductInfo,
    setEnvironmentDates = _useContext.setEnvironmentDates,
    setEnvironmentTeachers = _useContext.setEnvironmentTeachers,
    setEnvironmentAudience = _useContext.setEnvironmentAudience,
    setIsReadOnlyEnvironment = _useContext.setIsReadOnlyEnvironment,
    setSrcEnvironmentId = _useContext.setSrcEnvironmentId;
  var _useTeacherApi = (0, _useTeacherApi2.useTeacherApi)(isLearingSite),
    initTeacherData = _useTeacherApi.initTeacherData,
    saveEnviroment = _useTeacherApi.saveEnviroment,
    updateEnviroment = _useTeacherApi.updateEnviroment;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isSaveDisabled = _useState2[0],
    setIsSaveDisabled = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDuplicatedEnvTitle = _useState4[0],
    setIsDuplicatedEnvTitle = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSaveErrorVisible = _useState6[0],
    setIsSaveErrorVisible = _useState6[1];
  var onBack = function onBack() {
    if (userSessionData.role === 'admin') {
      setSliderView('schoolSelector');
    } else {
      onClose();
    }
  };
  var onSave = function onSave(environmentData) {
    setIsSaveErrorVisible(false);
    if (mode === 'create' || mode === 'duplicate') {
      setPreloaderMode('over');
      saveEnviroment(environmentData,
      // On "saveEnviroment" success
      function (enviromentId, enviromentAudienceId) {
        var _props$onSave;
        var savedEnvironmentIds = {
          Id: enviromentId,
          AudienceID: enviromentAudienceId
        };
        var savedEnvironmentData = _objectSpread(_objectSpread({}, environmentData), {}, {
          Ids: savedEnvironmentIds
        });
        setEnvironmentIds(savedEnvironmentIds);
        setPreloaderMode(undefined);
        props === null || props === void 0 ? void 0 : (_props$onSave = props.onSave) === null || _props$onSave === void 0 ? void 0 : _props$onSave.call(props, savedEnvironmentData);
        setSliderView('environmentSaved');
        setTimeout(function () {
          setUserEnvironments(userEnvironments ? [].concat(_toConsumableArray(userEnvironments), [savedEnvironmentData]) : [savedEnvironmentData]);
        }, 500);
      },
      // On "saveEnviroment" error
      function (error) {
        setPreloaderMode(undefined);
        setIsSaveDisabled(false);
        setIsSaveErrorVisible(true);
        console.error(error);
      });
    } else if (mode === 'update') {
      setPreloaderMode('over');
      updateEnviroment(environmentData,
      // On "updateEnviroment" success
      function () {
        var _props$onSave2;
        setPreloaderMode(undefined);
        props === null || props === void 0 ? void 0 : (_props$onSave2 = props.onSave) === null || _props$onSave2 === void 0 ? void 0 : _props$onSave2.call(props, environmentData);
        setSliderView('environmentSaved');
        setTimeout(function () {
          setUserEnvironments(userEnvironments ? [].concat(_toConsumableArray(userEnvironments.filter(function (e) {
            return e.Ids.Id !== environmentData.Ids.Id;
          })), [environmentData]) : [environmentData]);
        }, 500);
      },
      // On "updateEnviroment" error
      function (error) {
        setPreloaderMode(undefined);
        setIsSaveDisabled(false);
        setIsSaveErrorVisible(true);
        console.error(error);
      });
    }
  };
  var onSourceEnvironmentChange = function onSourceEnvironmentChange(sourceEnv) {
    if (sourceEnv) {
      setSrcEnvironmentId(sourceEnv.Ids.Id);
      setEnvironmentProductInfo(sourceEnv.ProductInfo);
      setEnvironmentTeachers(sourceEnv.Teachers);
      setEnvironmentAudience(sourceEnv.Audience);
      if (mode === 'update') {
        setEnvironmentIds(sourceEnv.Ids);
        setEnvironmentTitle(sourceEnv.Title);
        setEnvironmentDates(sourceEnv.Dates);
        setIsReadOnlyEnvironment(sourceEnv.IsArchive);
      } else if (mode === 'duplicate') {
        setEnvironmentIds({
          Id: '',
          AudienceID: ''
        });
        setEnvironmentTitle('');
        setEnvironmentDates({
          Start: new Date(Math.max.apply(Math, _toConsumableArray([new Date(), sourceEnv.Dates.Start ? new Date(sourceEnv.Dates.Start) : new Date(), schoolYear !== null && schoolYear !== void 0 && schoolYear.startDate ? new Date(schoolYear.startDate) : new Date()].map(function (date) {
            return date.getTime();
          })))),
          End: new Date(Math.min.apply(Math, _toConsumableArray([sourceEnv.Dates.End ? new Date(sourceEnv.Dates.End) : new Date(), schoolYear !== null && schoolYear !== void 0 && schoolYear.endDate ? new Date(schoolYear.endDate) : new Date()].map(function (date) {
            return date.getTime();
          }))))
        });
        setIsReadOnlyEnvironment(false);
      }
    } else {
      setSrcEnvironmentId(undefined);
    }
  };
  (0, _react.useEffect)(function () {
    var _userSessionData$scho;
    var schoolId = userSessionData.role === 'admin' ? environmentData.SchoolID : (_userSessionData$scho = userSessionData.schoolId) !== null && _userSessionData$scho !== void 0 ? _userSessionData$scho : '';
    if (schoolId) {
      setEnvironmentSchoolId(schoolId);
      initTeacherData(productInfo.ProductId, schoolId, mode !== 'create');
      var studyYearData = (0, _studyYear.getStudyYearDataByDate)(new Date());
      setSchoolYear({
        startDate: studyYearData.start,
        endDate: studyYearData.end
      });
    }
  }, [mode, productInfo.ProductId, userSessionData.role, userSessionData.schoolId, environmentData.SchoolID, initTeacherData, setEnvironmentSchoolId, setSchoolYear]);
  (0, _react.useEffect)(function () {
    setEnvironmentProductInfo(productInfo);
    if (mode === 'create' && schoolYear !== null && schoolYear !== void 0 && schoolYear.endDate) {
      setEnvironmentDates({
        Start: new Date(),
        End: new Date(schoolYear.endDate)
      });
    }
    if (mode === 'create' && defaultEnvironmentTeachers) {
      setEnvironmentTeachers(defaultEnvironmentTeachers);
    } else if (!srcEnvironmentId) {
      setEnvironmentTeachers([]);
    }
  }, [mode, schoolYear === null || schoolYear === void 0 ? void 0 : schoolYear.endDate, srcEnvironmentId, defaultEnvironmentTeachers, productInfo, setEnvironmentProductInfo, setEnvironmentTeachers, setEnvironmentDates, setSrcEnvironmentId]);
  (0, _react.useEffect)(function () {
    setSrcEnvironmentId(sourceEnvironmentId);
  }, [sourceEnvironmentId, setSrcEnvironmentId]);
  (0, _react.useEffect)(function () {
    var _environmentData$Titl, _environmentData$Audi, _environmentData$Audi2;
    var environmentInputTitle = ((_environmentData$Titl = environmentData.Title) === null || _environmentData$Titl === void 0 ? void 0 : _environmentData$Titl.trim()) || '';
    var isEnvironmentInfoValid = false;
    var isDuplicatedEnvironmentTitle = false;
    if (isInCreationMode) {
      isDuplicatedEnvironmentTitle = Boolean(environmentData.Teachers.length > 0 && environmentInputTitle.length > 0 && (userEnvironments === null || userEnvironments === void 0 ? void 0 : userEnvironments.find(function (env) {
        return env.Title === environmentInputTitle;
      })));
    } else if (srcEnvironmentId && !environmentData.IsArchive) {
      isDuplicatedEnvironmentTitle = Boolean(environmentData.Teachers.length > 0 && environmentInputTitle.length > 0 && (userEnvironments === null || userEnvironments === void 0 ? void 0 : userEnvironments.find(function (env) {
        return env.Ids.Id !== srcEnvironmentId && env.Title === environmentInputTitle;
      })));
    }
    if (!isDuplicatedEnvironmentTitle && environmentInputTitle.length > 0 && environmentData.Teachers.length > 0 && (((_environmentData$Audi = environmentData.Audience.Groups) === null || _environmentData$Audi === void 0 ? void 0 : _environmentData$Audi.length) > 0 || ((_environmentData$Audi2 = environmentData.Audience.SingleStudents) === null || _environmentData$Audi2 === void 0 ? void 0 : _environmentData$Audi2.length) > 0)) {
      isEnvironmentInfoValid = true;
    }
    setIsSaveDisabled(!isEnvironmentInfoValid);
    setIsDuplicatedEnvTitle(isDuplicatedEnvironmentTitle);
  }, [isInCreationMode, srcEnvironmentId, environmentData, userEnvironments]);
  var environmentNamePlaceholder = getLabel('environment_name_placeholder');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-EnvironmentManagerContainer'],
    "data-testid": "environmentEditorView",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Header, {
      title: getLabel(mode === 'create' ? 'mainViewCreateTitle' : mode === 'update' ? 'mainViewUpdateTitle' : 'mainViewDuplicateTitle')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [mode !== 'create' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_EnvironmentSelection.EnvironmentSelection, {
          selectedEnvironmentId: srcEnvironmentId,
          isLearingSite: isLearingSite,
          onChange: onSourceEnvironmentChange
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-EnvironmentManager_Row'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-EnvironmentManager_Cell_Label'],
            children: mode === 'update' ? getLabel('environment_edit_name') : getLabel('environment_name')
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-EnvironmentManager_Cell_Content'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                width: "".concat(environmentNamePlaceholder.length * 0.45, "em")
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Input, {
                id: "environmentName",
                type: "text",
                view: "none",
                maxLength: environmentTitleMaxLength,
                isDisabled: environmentData.IsArchive || mode === 'update' && !environmentData.Ids.Id,
                value: environmentData.Title,
                onChange: function onChange(value) {
                  setEnvironmentTitle(value);
                },
                borderRadius: {
                  borderRadius: 10
                },
                placeholder: environmentNamePlaceholder
              })
            }), isDuplicatedEnvTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-EnvironmentManager_Warning'],
              "data-testid": "environmentDuplicatedNameWarning",
              children: getLabel('environment_duplicated_name_warning').replace('{}', '')
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TeacherSelection.TeacherSelection, {
          isDisabled: environmentData.IsArchive || mode === 'update' && !environmentData.Ids.Id,
          selectedTeachers: (_environmentData$Teac = environmentData.Teachers) === null || _environmentData$Teac === void 0 ? void 0 : _environmentData$Teac.map(function (t) {
            return {
              value: t.UserID,
              label: t.UserName
            };
          }),
          onChange: function onChange(selectedTeachers) {
            setEnvironmentTeachers(selectedTeachers !== null && selectedTeachers !== void 0 && selectedTeachers.length ? selectedTeachers.map(function (t) {
              return {
                UserID: t.value,
                UserName: t.label,
                ContextGroupID: ''
              };
            }) : []);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-EnvironmentManager_AudiencePickerContainer'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-EnvironmentManager_Cell_Label'],
            children: getLabel('participants')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudiencePickerView.AudiencePickerView, {
            view: "inline"
          })]
        }), enableRangeDateSelection && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-EnvironmentManager_Row'],
          "data-testid": "environmentDates",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-EnvironmentManager_Cell_Label'],
            children: getLabel('schedule')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-EnvironmentManager_Cell_Content'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RangeDateSelection.RangeDateSelection, {
              isDisabled: environmentData.IsArchive || mode === 'update' && !environmentData.Ids.Id,
              minDate: environmentData.IsArchive ? environmentData.Dates.Start : new Date(),
              maxDate: environmentData.IsArchive ? environmentData.Dates.End : schoolYear !== null && schoolYear !== void 0 && schoolYear.endDate ? new Date(schoolYear.endDate) : undefined,
              startDate: environmentData.Dates.Start,
              endDate: environmentData.Dates.End,
              onChange: function onChange(startDate, endDate) {
                setEnvironmentDates({
                  Start: startDate,
                  End: endDate
                });
              }
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_main.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
          id: "backButton",
          view: "link",
          onClick: onBack,
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_main.Modal.Footer.Section, {
        children: [mode === 'update' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
          id: "deleteButton",
          view: "outlined",
          isDisabled: environmentData.Ids.Id.length <= 0,
          onClick: function onClick() {
            setSliderView('environmentDelete');
          },
          children: getLabel('delete')
        }), isSaveErrorVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-EnvironmentManager_Error'],
          children: getLabel('environment_error')
        }), (mode !== 'update' || !environmentData.IsArchive) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
          id: "saveButton",
          view: "contained",
          isDisabled: isSaveDisabled,
          onClick: function onClick() {
            onSave(environmentData);
            setTimeout(function () {
              setIsSaveDisabled(true);
            }, 0);
          },
          children: getLabel('save')
        })]
      })]
    })]
  });
};
exports.SliderEditorView = SliderEditorView;